import React from 'react';

export const ShowTwoReact: React.FC = () => {
  return (
      <div>
        hi
      </div>
    );
};

